<eo-base-form-control [label]="label" [help]="help" [errors]="errors">
  <div class="card">
    <p-pickList
        [source]="(difference$ | async) ?? sourceProducts"
        [target]="(httpSelected$ | async) ?? targetProducts"
        [sourceHeader]="sourceHeader"
        [targetHeader]="targetHeader"
        [dragdrop]="dragdrop"
        [responsive]="responsive"
        [sourceStyle]="sourceStyle"
        [targetStyle]="targetStyle"
        styleClass="w-full {{styleClass}}"
        [showSourceControls]="false"
        [showTargetControls]="false"
        [filterBy]="filterBy"
        [sourceFilterPlaceholder]="sourceFilterPlaceholder"
        [targetFilterPlaceholder]="targetFilterPlaceholder"
        breakpoint="1000px">
          <ng-template let-product pTemplate="item">
              <span>
                  {{ product[optionValue] }}
              </span>
          </ng-template>
    </p-pickList>
  </div>
</eo-base-form-control>
